import React, { useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import Helmet from "react-helmet";
import { DASHBOARD } from "common/viewContent";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChartColumn,
  faQrcode,
  faUsers,
} from "@fortawesome/free-solid-svg-icons";
import ReactApexChart from "react-apexcharts";
import { getDashboard } from "store/dashboard/actions";
import { FadeLoader } from "react-spinners";
const Dashboard = (props) => {
  const dispatch = useDispatch();
  const [dashboardData, setDashboardData] = useState(null);
  useEffect(() => {
    dispatch(
      getDashboard({
        callback: (err, data) => {
          if (!err) {
            setDashboardData(data);
          } else {
            console.error("Error fetching dashboard data:", err);
          }
        },
      })
    );
  }, [dispatch]);
  const chartOptions = {
    chart: {
      type: "line",
      zoom: {
        enabled: false,
      },
      toolbar: {
        show: false,
        tools: {
          download: false,
        },
      },
    },

    tooltip: {
      enabled: true,
    },
    title: {
      text: "Total Users Trends by Month",
      align: "left",
    },
    dataLabels: {
      enabled: false,
    },
    legend: {
      show: false,
    },
    colors: ["#227fd5"],
    series: [
      {
        name: "users ",
        //data: dashboardData?.userGraph?.map((it) => it.count),
      },
    ],
    xaxis: {
      categories: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
    },
  };
  return (
    <>
      {dashboardData?.length && (
        <div className="main-loader">
          <FadeLoader size={1000} />
        </div>
      )}
      <Helmet title={DASHBOARD.CURRENT_MODULE} />
      <section className="section">
        <div className="section-header">
          <h1>{DASHBOARD.CURRENT_MODULE}</h1>
          <div className="section-header-breadcrumb">
            <div className="breadcrumb-item">
              Welcome to Monte Sereno admin !{" "}
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-4 col-md-6 col-sm-12">
            <Link>
              <div className="card card-statistic-2 p-4 shadow-sm bg-gradient rounded-lg hover-card">
                <div className="row align-items-center justify-content-between">
                  <div className="col-md-6">
                    <span className="fw-bolder">Total Doctor : </span>
                    <span className="fw-bolder">
                      {dashboardData?.roleCounts[0].count}
                    </span>
                    <br />
                  </div>
                  <div className="col-md-6 d-flex justify-content-end align-items-center">
                    <div className="mr-3">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="21"
                        height="21"
                        viewBox="0 0 122.47 122.88"
                        fill="none"
                      >
                        <path
                          d="M84.58,103.47a4.09,4.09,0,1,1-4.08,4.09,4.08,4.08,0,0,1,4.08-4.09Zm3.61-60.62a3.89,3.89,0,0,1,2.2,1.48c1.08,1.39,1.38,3.64,1.08,6a15.16,15.16,0,0,1-2.21,6.2c-1.31,2-3,3.29-5,3.16-.14,6.51-3.33,9.5-7.49,13.41l-1.59,1.51-.54.51.13.09a14.67,14.67,0,0,1-1.58,1.1,17.71,17.71,0,0,1-4.61,2.47,20.48,20.48,0,0,1-6.84,1.12,21.4,21.4,0,0,1-7.11-1.1l-1-.36a16.18,16.18,0,0,1-3.74-1.66l-.5-.31a21.59,21.59,0,0,1-2.26,4.77L62.65,92.05,77.23,79.9A22.93,22.93,0,0,1,75,75.38c6.43,4.57,7.82,14.11,7.61,21.81,0,1-.06,1.26-.08,1.59a8.91,8.91,0,0,0-4.36,15,8.49,8.49,0,0,0,11.77.7,8.9,8.9,0,0,0,3.42-7,7.94,7.94,0,0,0-1.08-4c-1.5-2.6-3.13-3.36-5.62-4.6-.17-.09,0-.47,0-1.53a47.43,47.43,0,0,0-1.46-14.08,21,21,0,0,0,3.4,1.41c8.9,2.1,19.84,3,23.76,5.2a16,16,0,0,1,5,4.26c3.47,4.58,3.76,17.76,5,23.36-.31,3.28-2.16,5.16-5.82,5.44H5.82C2.17,122.6.31,120.71,0,117.44c1.26-5.6,1.56-18.79,5-23.36a15.58,15.58,0,0,1,5.05-4.26c5.57-3.1,19.22-3.94,28.3-6.46a33.06,33.06,0,0,0-1.58,8c-1,.77-3.64,1.67-4.47,2.66a38.55,38.55,0,0,0-3.86,5.53,2,2,0,0,0-.27,1c0,.28.29.57.17.81l-.19.37c-2.6,5-4.29,10.61-3.49,13A3.64,3.64,0,0,0,27.3,117a12.43,12.43,0,0,0,3.15.41c.31,0,.63,0,.94,0a3.07,3.07,0,0,0,.52.39,4.12,4.12,0,0,0,.67.32,2.58,2.58,0,0,0,.91.17A2.51,2.51,0,0,0,36,115.75a2.54,2.54,0,0,0-.23-1,2.58,2.58,0,0,0-2.38-1.61c-.92,0-2.23.46-2.23,1.38v0l0,.06-.64,0a9.17,9.17,0,0,1-2.33-.28c-.45-.12-.71-.29-.77-.48-.58-1.68,1-6.33,3.29-10.83l.29-.55a2,2,0,0,0,1-.88,34,34,0,0,1,3.41-4.92,7.09,7.09,0,0,1,3.38-1.72H39a10.53,10.53,0,0,1,1.72,1.55,30.64,30.64,0,0,1,3.6,5c.23.41.79.5,1,.89,2.65,4.28,4.14,9.19,3.78,11.06-.08.44-.44.7-1,.88a10.49,10.49,0,0,1-2.62.37,1.74,1.74,0,0,0-.1-.19v0c0-.92-1.32-1.35-2.24-1.38a2.58,2.58,0,0,0-2.38,1.61,2.71,2.71,0,0,0-.23,1,2.51,2.51,0,0,0,2.51,2.51,2.63,2.63,0,0,0,.92-.17,4,4,0,0,0,.66-.32,3.27,3.27,0,0,0,.36-.25h.36A12.22,12.22,0,0,0,49,117a3.88,3.88,0,0,0,2.9-3.05c.44-2.44-1.33-7.82-3.94-12.7a2,2,0,0,0,.16-.81,2.13,2.13,0,0,0-.28-1,36,36,0,0,0-4.1-5.7c-.83-.93-2.66-1.2-2.85-2.44-.5-3.23.9-7.23,3-10.71a15.15,15.15,0,0,0,1.46-2.19l.32-.44a8.32,8.32,0,0,1,3.41-2.08q-.73-.55-1.47-1.2L46.07,73.3l-.1-.09c-4-3.48-7.41-6.43-8-13.56-2.78-.24-4.75-2.88-5.72-6a15.2,15.2,0,0,1-.65-5.14,7.82,7.82,0,0,1,1.51-4.56,4.31,4.31,0,0,1,.63-.65l-.14-.09c-.64-8,1.23-21.82-7.43-24.44C42.51-1.55,60.51-5.27,75.6,7.13,91.28,8,98.85,30.64,88.19,42.85Z"
                          fill="black"
                        />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            </Link>
          </div>
          <div className="col-lg-4 col-md-6 col-sm-12">
            <Link>
              <div className="card card-statistic-2 p-4 shadow-sm bg-gradient rounded-lg hover-card">
                <div className="row align-items-center justify-content-between">
                  <div className="col-md-6">
                    <span className="fw-bolder">Total Chemist : </span>
                    <span className="fw-bolder">
                      {dashboardData?.roleCounts[2].count}
                    </span>
                    <br />
                  </div>
                  <div className="col-md-6 d-flex justify-content-end align-items-center">
                    <div className="mr-3">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        xmlnsXlink="http://www.w3.org/1999/xlink"
                        height="21px"
                        width="21px"
                        version="1.1"
                        id="Layer_1"
                        viewBox="0 0 504.123 504.123"
                        xmlSpace="preserve"
                      >
                        <g>
                          <path
                            style={{ fill: "#D1B302" }}
                            d="M241.073,203.768c10.027,11.28,3.663,33.296-14.218,49.215   c-17.881,15.896-114.018,85.031-124.062,73.767c-10.012-11.296,69.892-98.706,87.773-114.601   C208.431,196.246,231.046,192.496,241.073,203.768z"
                          />
                          <path
                            style={{ fill: "#D1B302" }}
                            d="M263.05,203.768c-10.027,11.28-3.663,33.296,14.218,49.215   c17.881,15.896,114.018,85.031,124.062,73.767c10.012-11.296-69.892-98.706-87.773-114.601   C295.692,196.246,273.077,192.496,263.05,203.768z"
                          />
                        </g>
                        <g>
                          <path
                            style={{ fill: "#B79904" }}
                            d="M348.538,358.951c0,19.511-15.817,124.676-35.336,124.676c-19.495,0-35.304-105.173-35.304-124.676   c0-19.495,15.817-35.32,35.304-35.32C332.721,323.631,348.538,339.464,348.538,358.951z"
                          />
                          <path
                            style={{ fill: "#B79904" }}
                            d="M228.218,361.905c0,19.511-15.817,124.676-35.336,124.676c-19.495,0-35.304-105.173-35.304-124.676   c0-19.495,15.817-35.32,35.304-35.32C212.401,326.585,228.218,342.418,228.218,361.905z"
                          />
                        </g>
                        <path
                          style={{ fill: "#CE1111" }}
                          d="M351.705,315.242c0,126.322-44.599,84.259-99.643,84.259c-55.028,0-99.643,42.063-99.643-84.259  c0-72.231,44.631-130.788,99.643-130.788C307.09,184.462,351.705,243.019,351.705,315.242z"
                        />
                        <path
                          style={{ fill: "#D1B302" }}
                          d="M351.705,315.242c0,126.322-44.599,84.259-99.643,84.259c-55.028,0-99.643,42.063-99.643-84.259  c0-72.231,44.631-130.788,99.643-130.788C307.09,184.462,351.705,243.019,351.705,315.242z"
                        />
                        <path
                          style={{ fill: "#EACE00" }}
                          d="M252.062,184.462c-53.28,0-96.681,54.957-99.383,124.014c3.513,107.874,46.655,69.372,99.383,69.372  c52.744,0,95.862,38.51,99.383-69.372C348.743,239.419,305.349,184.462,252.062,184.462z"
                        />
                        <path
                          style={{ fill: "#232728" }}
                          d="M232.629,487.219c0,14.935-17.802,16.904-39.739,16.904s-39.739-1.969-39.739-16.904  c0-14.935,17.802-35.509,39.739-35.509S232.629,472.277,232.629,487.219z"
                        />
                        <path d="M232.629,487.219c0,14.935-17.802,16.904-39.739,16.904s-39.739-1.969-39.739-16.904" />
                        <path
                          style={{ fill: "#232728" }}
                          d="M350.988,487.219c0,14.935-17.802,16.904-39.739,16.904s-39.739-1.969-39.739-16.904  c0-14.935,17.802-35.509,39.739-35.509S350.988,472.277,350.988,487.219z"
                        />
                        <path d="M350.988,487.219c0,14.935-17.802,16.904-39.739,16.904s-39.739-1.969-39.739-16.904" />
                        <path
                          style={{ fill: "#D1B302" }}
                          d="M173.088,235.725c21.835,11.059,49.191,16.691,78.99,16.691c29.783,0,57.139-5.632,78.966-16.691  c-18.211-31.106-46.773-51.263-78.982-51.263C219.861,184.462,191.291,204.603,173.088,235.725z"
                        />
                        <polygon
                          style={{ fill: "#FFFFFF" }}
                          points="298.016,207.415 252.062,307.2 206.108,207.415 252.062,161.461 "
                        />
                        <path
                          style={{ fill: "#EAE5DF" }}
                          d="M280.513,189.913c-9.011-3.529-18.558-5.451-28.451-5.451s-19.448,1.914-28.459,5.451l-17.495,17.503  l19.999,43.433c8.397,1,17.046,1.568,25.97,1.568c8.901,0,17.558-0.567,25.939-1.568l20-43.433L280.513,189.913z"
                        />
                        <path
                          style={{ fill: "#F7CCB0" }}
                          d="M381.015,124.258c0,63-57.738,94.681-128.937,94.681c-71.215,0-128.969-31.673-128.969-94.681  C123.108,61.227,180.862,0,252.077,0C323.277,0,381.015,61.227,381.015,124.258z"
                        />
                        <path
                          style={{ fill: "#F7BC8F" }}
                          d="M381.015,124.258c0,63-57.738,94.681-128.937,94.681c-71.215,0-128.969-31.673-128.969-94.681  c0-63.031,57.754-105.236,128.969-105.236C323.277,19.023,381.015,61.227,381.015,124.258z"
                        />
                        <path
                          style={{ fill: "#EAAF88" }}
                          d="M381.015,124.258c0,63-57.738,94.681-128.937,94.681c-71.215,0-128.969-31.673-128.969-94.681"
                        />
                        <circle
                          style={{ fill: "#113E49" }}
                          cx="190.748"
                          cy="133.569"
                          r="11.532"
                        />
                        <path d="M202.279,133.569c0,6.388-5.167,11.54-11.54,11.54c-6.372,0-11.524-5.152-11.524-11.54" />
                        <path
                          style={{ fill: "#FFD3C5" }}
                          d="M213.496,157.633c-0.614,0-1.245-0.228-1.725-0.725c-5.632-5.616-13.107-8.72-21.047-8.72h-0.016  c-7.94,0-15.399,3.111-21,8.72c-0.953,0.953-2.489,0.969-3.434,0c-0.953-0.922-0.985-2.458-0.031-3.419  c6.538-6.538,15.218-10.153,24.458-10.153h0.016c9.263,0,17.951,3.584,24.505,10.138c0.937,0.937,0.937,2.505,0,3.434  C214.756,157.397,214.142,157.633,213.496,157.633z"
                        />
                        <circle
                          style={{ fill: "#113E49" }}
                          cx="313.423"
                          cy="133.569"
                          r="11.532"
                        />
                        <path d="M301.859,133.569c0,6.388,5.151,11.54,11.54,11.54c6.372,0,11.524-5.152,11.524-11.54" />
                        <path
                          style={{ fill: "#FFD3C5" }}
                          d="M290.643,157.633c0.599,0,1.229-0.228,1.709-0.725c5.632-5.616,13.107-8.72,21.047-8.72h0.016  c7.94,0,15.415,3.111,21.016,8.72c0.937,0.953,2.473,0.969,3.434,0c0.953-0.922,0.969-2.458,0.016-3.419  c-6.506-6.538-15.218-10.153-24.458-10.153h-0.016c-9.248,0-17.936,3.584-24.505,10.138c-0.922,0.937-0.922,2.505,0,3.434  C289.382,157.397,289.997,157.633,290.643,157.633z"
                        />
                        <g>
                          <path
                            style={{ fill: "#845824" }}
                            d="M216.954,168.164h-56.8c-11.24,0-20.385-9.145-20.385-20.385v-30.744   c0-11.24,9.145-20.385,20.385-20.385h56.8c11.24,0,20.385,9.145,20.385,20.385v30.744   C237.34,159.019,228.194,168.164,216.954,168.164z M160.154,112.404c-2.552,0-4.632,2.08-4.632,4.632v30.744   c0,2.552,2.079,4.632,4.632,4.632h56.8c2.552,0,4.632-2.08,4.632-4.632v-30.744c0-2.552-2.079-4.632-4.632-4.632   C216.954,112.404,160.154,112.404,160.154,112.404z"
                          />
                          <path
                            style={{ fill: "#845824" }}
                            d="M145.676,140.28h-30.523c-4.356,0-7.877-3.521-7.877-7.877c0-4.356,3.521-7.877,7.877-7.877h30.523   c4.356,0,7.877,3.521,7.877,7.877C153.553,136.759,150.032,140.28,145.676,140.28z"
                          />
                          <path
                            style={{ fill: "#845824" }}
                            d="M343.969,168.157h-56.801c-11.24,0-20.385-9.145-20.385-20.385v-30.736   c0-11.24,9.145-20.385,20.385-20.385h56.801c11.24,0,20.385,9.145,20.385,20.385v30.736   C364.355,159.011,355.21,168.157,343.969,168.157z M287.169,112.404c-2.552,0-4.632,2.08-4.632,4.632v30.736   c0,2.552,2.079,4.632,4.632,4.632h56.801c2.552,0,4.632-2.08,4.632-4.632v-30.736c0-2.552-2.079-4.632-4.632-4.632   C343.969,112.404,287.169,112.404,287.169,112.404z"
                          />
                          <path
                            style={{ fill: "#845824" }}
                            d="M388.97,140.28h-30.523c-4.356,0-7.877-3.521-7.877-7.877c0-4.356,3.521-7.877,7.877-7.877h30.523   c4.356,0,7.877,3.521,7.877,7.877C396.847,136.759,393.326,140.28,388.97,140.28z"
                          />
                          <path
                            style={{ fill: "#845824" }}
                            d="M274.66,138.004h-43.811c-4.356,0-7.877-3.521-7.877-7.877c0-4.356,3.521-7.877,7.877-7.877h43.811   c4.356,0,7.877,3.521,7.877,7.877C282.537,134.483,279.016,138.004,274.66,138.004z"
                          />
                        </g>
                        <path
                          style={{ fill: "#FFFFFF" }}
                          d="M257.308,381.369c0,2.891-2.339,5.246-5.246,5.246l0,0c-2.891,0-5.246-2.355-5.246-5.246v-85.339  c0-2.907,2.355-5.254,5.246-5.254l0,0c2.907,0,5.246,2.347,5.246,5.254V381.369z"
                        />
                        <path
                          style={{ fill: "#513715" }}
                          d="M266.398,165.935H237.71c-13.273,0-24.033,10.768-24.033,24.033v18.692  c0,13.273,10.76,24.025,24.033,24.025h28.688c13.296,0,24.033-10.752,24.033-24.025v-18.692  C290.43,176.711,279.694,165.935,266.398,165.935z M274.653,200.814c0,7.814-6.333,14.147-14.147,14.147H243.61  c-7.814,0-14.155-6.333-14.155-14.147v-10.996c0-7.806,6.341-14.155,14.155-14.155h16.896c7.814,0,14.147,6.349,14.147,14.155  V200.814z"
                        />
                        <path
                          style={{ fill: "#227FEF" }}
                          d="M128.323,330.831c0,11.973-9.689,21.662-21.662,21.662l0,0c-11.973,0-21.662-9.689-21.662-21.662l0,0  c0-11.973,9.689-21.662,21.662-21.662l0,0C118.634,309.169,128.323,318.858,128.323,330.831L128.323,330.831z"
                        />
                        <path
                          style={{ fill: "#0A5BDD" }}
                          d="M106.661,309.169L106.661,309.169c11.973,0,21.662,9.689,21.662,21.662l0,0  c0,11.973-9.689,21.662-21.662,21.662l0,0"
                        />
                        <path
                          style={{ fill: "#227FEF" }}
                          d="M375.784,330.831c0-11.981,9.689-21.677,21.662-21.677l0,0c11.973,0,21.677,9.689,21.677,21.677l0,0  c0,11.957-9.704,21.662-21.677,21.662l0,0C385.481,352.492,375.784,342.788,375.784,330.831L375.784,330.831z"
                        />
                        <path
                          style={{ fill: "#0A5BDD" }}
                          d="M397.446,352.492L397.446,352.492c-11.973,0-21.662-9.704-21.662-21.662l0,0  c0-11.981,9.689-21.677,21.662-21.677l0,0"
                        />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            </Link>
          </div>
          <div className="col-lg-4 col-md-6 col-sm-12">
            <Link>
              <div className="card card-statistic-2 p-4 shadow-sm bg-gradient rounded-lg hover-card">
                <div className="row align-items-center justify-content-between">
                  <div className="col-md-6">
                    <span className="fw-bolder">Total Patient: </span>
                    <span className="fw-bolder">
                      {dashboardData?.roleCounts[1].count}
                    </span>
                    <br />
                  </div>
                  <div className="col-md-6 d-flex justify-content-end align-items-center">
                    <div className="mr-3">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="21"
                        height="21"
                        viewBox="0 0 459.384 459.384"
                        fill="none"
                      >
                        <path
                          d="M117.31,178.834l105.938,69.969c8.365,5.525,19.437,4.672,26.859-2.121c3.935-1.236-1.911,2.226,84.107-54.543
            l90.077,13.361c11.269,1.672,21.772-6.112,23.445-17.388c1.673-11.275-6.112-21.772-17.388-23.445l-97.885-14.519
            c-5.029-0.747-10.154,0.39-14.397,3.19l-42.884,28.302l-17.292-13.48c-9.782,10.236-7.344,7.684-17.528,18.34
            c-6.994,7.318-17.698,8.984-26.384,4.909l-62.156-29.269c70.819,12.611,66.147,11.895,68.314,11.895
            c4.652,0,9.16-1.891,12.434-5.317l47.478-49.679c6.563-6.868,6.316-17.755-0.551-24.318c-6.869-6.563-17.757-6.316-24.319,0.551
            l-41.106,43.012l-56.219-10.011l43.922-3.86l-27.733-21.62c-11.17-8.708-27.285-6.712-35.993,4.458l-26.83,34.416
            C102.032,153.45,104.83,170.591,117.31,178.834z"
                          fill="currentColor"
                        />
                        <circle
                          cx="78.871"
                          cy="90.141"
                          r="37.963"
                          fill="currentColor"
                        />
                        <path
                          d="M435.425,275.642c9.276,3.358,19.526-1.439,22.887-10.72c3.36-9.28-1.44-19.527-10.72-22.887l-91.068-32.972
            c-5.222-1.891-11.027-1.246-15.708,1.745l-103.222,65.969L27.693,138.727c-8.246-5.422-19.328-3.135-24.751,5.112
            c-5.423,8.246-3.136,19.328,5.111,24.751l219.583,144.417c2.978,1.959,6.398,2.94,9.82,2.94c3.343,0,6.689-0.937,9.623-2.813
            l10.533-6.732l30.756,65.062h-51.031c-9.87,0-17.871,8.001-17.871,17.871s8.001,17.871,17.871,17.871H438.66
            c9.87,0,17.871-8.001,17.871-17.871s-8.001-17.871-17.871-17.871h-54.717l-49.685-114.047l18.382-11.748L435.425,275.642z"
                          fill="currentColor"
                        />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            </Link>
          </div>
          <div className="col-lg-4 col-md-6 col-sm-12">
            <Link>
              <div className="card card-statistic-2 p-4 shadow-sm bg-gradient rounded-lg hover-card">
                <div className="row align-items-center justify-content-between">
                  <div className="col-md-6">
                    <span className="fw-bolder">Total User: </span>
                    <span className="fw-bolder">
                      {dashboardData?.totalCount}
                    </span>
                  </div>
                  <div className="col-md-6 d-flex justify-content-end align-items-center">
                    <div className="mr-3">
                      <svg
                        width="25"
                        height="25"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M12 4C13.0609 4 14.0783 4.42143 14.8284 5.17157C15.5786 5.92172 16 6.93913 16 8C16 9.06087 15.5786 10.0783 14.8284 10.8284C14.0783 11.5786 13.0609 12 12 12C10.9391 12 9.92172 11.5786 9.17157 10.8284C8.42143 10.0783 8 9.06087 8 8C8 6.93913 8.42143 5.92172 9.17157 5.17157C9.92172 4.42143 10.9391 4 12 4ZM12 14C16.42 14 20 15.79 20 18V20H4V18C4 15.79 7.58 14 12 14Z"
                          fill="black"
                        />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            </Link>
          </div>
          {/* <div className="col-lg-4 col-md-6 col-sm-12">
            <div className="card card-statistic-2 p-4 shadow-sm bg-gradient rounded-lg hover-card">
              <div className="row  align-items-center justify-content-between">
                <div className="col-md-6 ">
                  <span className="fw-bolder col-6 ">Revenue:</span>
                  <span className="fw-bolder col-6 rounded-5 border-2 border-danger ">
                    $.{dashboardData?.totalRevenueInUSD}
                  </span>
                  <span className="fw-bolder col-6 ">Revenue:</span>
                  <span className="fw-bolder col-6 rounded-5 border-2 border-danger ">
                    ₾{dashboardData?.totalRevenueInGEL || 0}
                  </span>
                </div>
                <div className="col-md-6 d-flex justify-content-end align-items-center">
                  <div className="mr-3">
                    <FontAwesomeIcon
                      color="red"
                      size="2x"
                      style={{ marginRight: "10px" }}
                      icon={faChartColumn}
                      className="icon"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div> */}
        </div>
        <div className="p-4">
          <ReactApexChart
            options={chartOptions}
            series={chartOptions.series}
            type="line"
            height={350}
          />
          <p className="d-flex justify-content-center align-items-center p-4 ">
            Registered All User Chart
          </p>
        </div>
      </section>
    </>
  );
};
const mapStateToProps = (state) => {
  return {
    isAuthenticated: state.Auth.authToken,
    user: state.Auth.Auth,
  };
};
function mapDispatchToProps(dispatch) {
  return { dispatch };
}
export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);
